'use strict';
//Utilities
var ContentService = require('../../services/ContentService');
//Constants
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var Constants = require('../../constants/YourDetailsConstants');
//var YourDetailsConstants = require('../../constants/YourDetailsConstants.js');
var YesNoValues = ApplicationConstants.YesNoValues;
var YesNoRadioData = ApplicationConstants.YesNoRadioData;
//Action
var YourDetailsActions = require('../../actions/YourDetailsActions');
//React/Components
var React = require('react');
var RadioInput = require('../Common/RadioInput.jsx');
var TextInput = require('../Common/TextInput.jsx');
var SelectInput = require('../Common/SelectInput.jsx');
var Country = require('../YourDetails/Country.jsx');

var TaxResidence = React.createClass({
    propTypes: {
        index: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
        section: React.PropTypes.string,
        showQuestion: React.PropTypes.bool,
        data: React.PropTypes.object.isRequired,
        errorList: React.PropTypes.array
    },
    getDefaultProps: function () {
        return {
            index: '',
            section: '',
            showQuestion: true,
            errorList: []
        };
    },
    updateYourDetailsData: function (event) {
        var fieldName = event.target.model;
        var value = event.target.value;

        YourDetailsActions.updateYourDetailsData(fieldName, event.target.id, value, this.props.index);
        if (fieldName.indexOf('otherCountryTaxResidence') !== -1 && this.shouldDisable(value)){
            let countryIndex = fieldName.replace('otherCountryTaxResidence', '');
            YourDetailsActions.updateYourDetailsData('hasTinExemptionReason' + countryIndex, this.refs['tinExemptionReason'+countryIndex].props.id, undefined, this.props.index); 
            YourDetailsActions.updateYourDetailsData('tinExemptionReason' + countryIndex, this.refs['tinExemptionReason'+countryIndex].props.id, '', this.props.index); 
        }
        if (fieldName.indexOf('hasTinExemption') !== -1) {
            var index = fieldName.replace('hasTinExemptionReason', '');
            if (value === YesNoValues.NO) {
                YourDetailsActions.updateYourDetailsData('tinExemptionReason' + index, this.refs['tinExemptionReason'+index].props.id, '', this.props.index);
            }
            else {
                YourDetailsActions.updateYourDetailsData('tin'+index, this.refs['tin'+index].props.id, '', this.props.index);
            }
        }
    },
    getLabelAndIds: function () {
                return {
                    question: {
                        label: 'Besides Australia, are you a tax resident of any other country?',
                        id: 'isOtherCountryTaxResident'
                    },
                    country: [{
                        countryId: 'otherCountryTaxResidence1',
                        tinId: 'tin1',
                        exemptionReasonId: 'tinExemptionReason1',
                        hasExemptionReasonId: 'hasTinExemptionReason1'
                    }, {
                        countryId: 'otherCountryTaxResidence2',
                        tinId: 'tin2',
                        exemptionReasonId: 'tinExemptionReason2',
                        hasExemptionReasonId: 'hasTinExemptionReason2'
                    }, {
                        countryId: 'otherCountryTaxResidence3',
                        tinId: 'tin3',
                        exemptionReasonId: 'tinExemptionReason3',
                        hasExemptionReasonId: 'hasTinExemptionReason3'
                    }]
                };
    },
    shouldDisable: (value) => { return value === Constants.Values.COUNTRY_UNITED_STATES },
    isExisting: () => { return window.NOA.userContext.isExisting },
    render: function () {
        var labelAndIds = this.getLabelAndIds();
        var content = ContentService.getContent().yourDetails;
        
        var countryComponent = function (data, index) {

            this.props.data[data.hasExemptionReasonId] =
                this.props.data[data.hasExemptionReasonId] ||
                (this.props.data[data.tinId]
                    ? YesNoValues.NO
                    : (this.props.data[data.exemptionReasonId] ? YesNoValues.YES : undefined));
            

            if (this.props.data.isOtherCountryTaxResident === YesNoValues.YES || !this.props.showQuestion) {
                return (
                    <div key={index} className="container form-actions">
                        <div className="pull-right">
                            <span className="badge primary form-section">{index + 1}</span>
                        </div>
                        <div>
                            <Country id={this.props.section + data.countryId + this.props.index}
                                     label={this.props.countryLabel}
                                     value={this.props.data[data.countryId]}
                                     onBlur={this.updateYourDetailsData}
                                     model={data.countryId}
                                     errorList={this.props.errorList}
                                     disabled={index === 0 && this.props.data['otherCountryTaxResidenceReadonly']}
                                     mandatory={index === 0}
                                     excludeCountryList={[Constants.Values.COUNTRY_AUSTRALIA]}
                                     helpText={content.tinCountry}
                                     className="select-tax-country" />

                            <RadioInput label="Select one of the following"
                                        id={this.props.section + data.hasExemptionReasonId + this.props.index}
                                        data={[{ id: YesNoValues.NO, name: 'Enter your Tax Identification Number (TIN)', isHidden: false }, 
                                        { id: YesNoValues.YES, name: 'Select exemption reason', isHidden: false, isDisabled:  this.shouldDisable(this.props.data[data.countryId]) }]}
                                        value={this.props.data[data.hasExemptionReasonId]}
                                        errorList={this.props.errorList}
                                        onChange={this.updateYourDetailsData}
                                        model={data.hasExemptionReasonId}/>

                            <TextInput id={this.props.section + data.tinId + this.props.index}
                                       label="Tax Identification Number (TIN)"
                                       ref={data.tinId}
                                       placeholder="TIN"
                                       value={this.props.data[data.tinId]}
                                       model={data.tinId}
                                       onBlur={this.updateYourDetailsData}
                                       isHidden={this.props.data[data.hasExemptionReasonId] !== YesNoValues.NO}
                                       errorList={this.props.errorList}
                                       helpText={this.isExisting() ? content.tinNumberExisting : content.tinNumber}
                                       className="form-text tin-number" />

                            <SelectInput id={this.props.section + data.exemptionReasonId + this.props.index}
                                         placeholder="Exemption reason"
                                         ref={data.exemptionReasonId}
                                         label="Select exemption reason"
                                         options={Constants.TinExemtionReasonData}
                                         value={this.props.data[data.exemptionReasonId]}
                                         onChange={this.updateYourDetailsData}
                                         className="select-tin-exemption"
                                         model={data.exemptionReasonId}
                                         errorList={this.props.errorList}
                                         helpText={content.tinExemptionReason}
                                         isHidden={this.props.data[data.hasExemptionReasonId] !== YesNoValues.YES} />
                                
                        </div>
                    </div>
                );
            }
            else{
                return null;
            }
        };
        return (
            <div>
                {this.props.showQuestion ? <RadioInput id={this.props.section + labelAndIds.question.id + this.props.index}
                                                       data={YesNoRadioData}
                                                       value={this.props.data[labelAndIds.question.id]}
                                                       label={labelAndIds.question.label}
                                                       onChange={this.updateYourDetailsData}
                                                       model={labelAndIds.question.id}
                                                       errorList={this.props.errorList}
                                                       note={content.otherCountryOfTaxResidence}
                                                       disabled={this.props.data[labelAndIds.question.id + 'Readonly']} />
                                          : null}

                <div className="form-section">
                    {labelAndIds.country.map(countryComponent, this)}
                </div>
            </div>
        );
    }
});

module.exports = TaxResidence;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/TaxResidence.jsx